import React from 'react';
import useTranslation from '../../hooks/useTranslation';

function CookiePreferencesFooterLink() {
  const { translateText } = useTranslation();

  const showCookiePreferencesDisplay = () => {
    window.OneTrust?.ToggleInfoDisplay();
  };

  return (
    <li key="cookie-preferences-footer-link">
      <button
        type="button"
        onClick={showCookiePreferencesDisplay}
        title={translateText('Change cookie consents')}
        className="change-cookie-preferences-button"
        aria-haspopup="true"
      >
        {translateText('Change cookie consents')}
      </button>
    </li>
  );
}

export default CookiePreferencesFooterLink;
